(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/utils.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/utils.js');

const { formatOrgNumber } = svs.ticket_partner.utils;
const getTickets = ({ articles }) => _.values(articles).map((article) => ({
  numberOfTickets: parseInt(article.count, 10),
  price: parseInt(article.price, 10),
  ticketTitle: article.name,
  ticketId: article.articleId
}));

const createPhysicalOrderRequest = ({ adressForm, articles }) => ({
  address: adressForm.address1,
  city: adressForm.city,
  companyName: adressForm.companyName,
  deliverLatest: adressForm.deliverLatest,
  deliveryAddress: adressForm.deliveryAddress,
  email: adressForm.eMail,
  fullName: adressForm.contact,
  message: adressForm.message,
  orgNumber: formatOrgNumber(adressForm.organizationNumber.replace('-', ''), false),
  phone: adressForm.phone,
  tickets: getTickets({ articles }),
  zipCode: adressForm.zip?.replaceAll(' ', '')
});

svs.ticket_partner.physicalTickets.utils = {
  createPhysicalOrderRequest
};


 })(window);